import TableComponent from "../../components/table-component/table-component";

const TablePage = () => {
    return <TableComponent/>
}

export default TablePage;